import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerAcessCESComponent } from './crud-ces/crud-ces.component';
import { CustomerAcessIndexComponent } from './crud-index/crud-index.component';

const routes: Routes = [
  {
    path: '',
    component: CustomerAcessIndexComponent,
  },
  {
    path: 'create',
    component: CustomerAcessCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: CustomerAcessCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: CustomerAcessCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerAcessRoutingModule {}
